import { useState, useRef, useEffect } from "react";
import { MapPin } from "lucide-react";
import { US_METROS } from "@/lib/regions";

const fmtMult = (m) => (m > 1 ? `+${Math.round((m - 1) * 100)}%` : m < 1 ? `${Math.round((m - 1) * 100)}%` : "avg");

export const LocationPicker = ({ value, onChange, placeholder = "Search a city, e.g. Austin, TX", testid = "location", autoFocus = false, onKeyDown, inputClassName = "" }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const h = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", h);
    return () => document.removeEventListener("mousedown", h);
  }, []);

  const q = (value || "").toLowerCase();
  const matches = (q.trim()
    ? US_METROS.filter((m) => m.label.toLowerCase().includes(q))
    : US_METROS
  ).slice(0, 8);

  const pick = (label) => { onChange(label); setOpen(false); };

  return (
    <div className="relative" ref={ref}>
      <input
        data-testid={`${testid}-input`}
        value={value || ""}
        autoFocus={autoFocus}
        onChange={(e) => { onChange(e.target.value); setOpen(true); }}
        onFocus={() => setOpen(true)}
        onKeyDown={onKeyDown}
        placeholder={placeholder}
        className={inputClassName || "w-full rounded-lg border border-input bg-card px-3 py-2.5 outline-none focus:border-primary focus:ring-2 focus:ring-primary/30"}
      />
      {open && matches.length > 0 && (
        <div data-testid={`${testid}-dropdown`} className="absolute z-50 mt-1 w-full max-h-60 overflow-auto rounded-lg border border-border bg-popover shadow-xl animate-fade-up">
          {matches.map((m) => (
            <button
              type="button"
              key={m.label}
              data-testid={`${testid}-option-${m.label.replace(/[^a-z0-9]+/gi, "-").toLowerCase()}`}
              onClick={() => pick(m.label)}
              className="flex w-full items-center justify-between gap-3 px-3 py-2 text-sm hover:bg-secondary transition-colors"
            >
              <span className="flex items-center gap-2 truncate"><MapPin className="h-3.5 w-3.5 text-primary shrink-0" />{m.label}</span>
              <span className={`text-xs font-mono shrink-0 ${m.mult > 1 ? "text-orange-500" : m.mult < 1 ? "text-emerald-500" : "text-muted-foreground"}`}>{fmtMult(m.mult)}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
